<template src="@/components/WelcomeModal.html" />
<style lang="scss" scoped src="@/components/WelcomeModal.scss" />
<script>

import {
    SfButton,
    SfModal,
    SfBar
} from '@storefront-ui/vue';
import { configuration } from "@/config/InstanceConfiguration";

export default {
    name: 'WelcomeModal',
    components: {
        SfButton,
        SfModal,
        SfBar
    },
    computed: {
        isWelcomeModal: function() { return this.$store.getters.isWelcomeModal; },
        continueShoppingButtonClasses: () => configuration.forms.buttons.continueShopping.classes,
        goToAccountButtonClasses: () => configuration.forms.buttons.goToMyAccount.classes
    },

    methods: {
        toggleWelcomeModal() {
            this.$store.dispatch('toggleWelcomeModal', { customer: null })
        },
        goToAccount() {
            this.$store.dispatch('toggleWelcomeModal', { customer: null })
            this.$router.push("/mon-compte").catch()
        }
    }
};
</script>